module.exports = __webpack_public_path__ + "img/30_5.0ec1cfa5.png";